'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _utils = require('../utils');

var utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SessionStackLoader = function () {
  function SessionStackLoader(emitter, options) {
    (0, _classCallCheck3.default)(this, SessionStackLoader);

    this._emitter = emitter;
    this._options = options;
  }

  (0, _createClass3.default)(SessionStackLoader, [{
    key: '_setupParentListeners',
    value: function _setupParentListeners() {
      var _this = this;

      this._emitter.listen('WIX_LIVERECORDING_PING', function (e) {
        _this._emitter.emit('WIX_LIVERECORDING_PONG', '', e.source, e.origin);
      });
    }
  }, {
    key: '_setupChildListeners',
    value: function _setupChildListeners() {
      var _this2 = this;

      this._emitter.listenOnce('WIX_LIVERECORDING_PONG', function () {
        _this2._setupSessionStack();
      });
    }
  }, {
    key: '_setupSessionStack',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        var _utils$getUserDetails, userId, userDetails, additionalDetails, l;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _utils$getUserDetails = utils.getUserDetails(this._options), userId = _utils$getUserDetails.userId, userDetails = _utils$getUserDetails.userDetails;
                additionalDetails = this._options.identifyData || {};

                l = function l(a, b) {
                  var c = window;
                  c.SessionStack = a;
                  c[a] = c[a] || function () {
                    c[a].q = c[a].q || [];
                    c[a].q.push(arguments);
                  };
                  c[a].t = b;
                  var displayName = userDetails && userDetails.displayName ? userDetails.displayName : '';
                  utils.lazyLoadScript('https://cdn-wix.sessionstack.com/sessionstack.js', 'sessionstack-jstag', function () {
                    window['sessionstack']('identify', (0, _extends3.default)({
                      displayName: displayName,
                      userId: userId,
                      userDetails: userDetails
                    }, additionalDetails));
                  });
                };

                l('sessionstack', {
                  token: this._options.debug ? '18babaeb9f2b4493917b870e09bb8591' : 'a581766651294671abc7961777340e98',
                  isIframe: window !== window.top
                });

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _setupSessionStack() {
        return _ref.apply(this, arguments);
      }

      return _setupSessionStack;
    }()
  }, {
    key: 'setup',
    value: function setup() {
      if (utils.getCookieValue('wixRec') === 'true') {
        this._setupParentListeners();
        this._setupSessionStack();
      } else if (!utils.isWixOrigin()) {
        this._setupChildListeners();
        this._emitter.emit('WIX_LIVERECORDING_PING', '', window.parent);
      }
    }
  }]);
  return SessionStackLoader;
}();

exports.default = SessionStackLoader;